import { atom } from 'recoil';
import Ticket from '../../interfaces/api/Ticket';

export default atom({
  key: 'tickets',
  default: {} as { [key: string]: Ticket },
});
